// services/ttsApi.js
import { createApi, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { deviceAxiosQuery } from '../../utils/axios/device.axios';
import { DEVICE_INFO_API_URL } from '../../config';

export const ttsApi = createApi({
  reducerPath: 'ttsApi',
  baseQuery: deviceAxiosQuery(), // leave this normal
  endpoints: (builder) => ({
    generateSpeech: builder.mutation<Blob, string>({
		queryFn: async (text: string) => {
        try {
          const response = await fetch(`${DEVICE_INFO_API_URL}/tts`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              // Include auth headers if needed
            },
            body: JSON.stringify({ text, voice: 'alloy' }),
          });

          if (!response.ok) {
            return {
              error: {
                status: response.status,
                data: await response.text(),
              } as FetchBaseQueryError,
            };
          }

          // Parse audio/mpeg response as Blob
          const blob = await response.blob();
          return { data: blob };
        } catch (err) {
			const error = err as {message: string}
			return {
				error: {
				  status: 500,
				  data: error.message,
				} as FetchBaseQueryError,
			  };
        }
      },
    }),
  }),
});

export const { useGenerateSpeechMutation } = ttsApi;
